import React, { useState } from 'react';

import { images } from '../../constants';
import { BsTwitter, BsInstagram, BsGithub, BsLinkedin, BsWhatsapp } from 'react-icons/bs';
// import { FaFacebookF } from 'react-icons/fa';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:ravisingh02082001@gmail.com" className="p-text">ravisingh02082001@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+91 7977183690" className="p-text">+91 7977183690</a>
        </div>
        <div className="app__footer-card">
        <div className="app__social-small">
          <div>
          <a href='https://twitter.com/aadrian_leo?t=cxH9bivL6X2Rd12fTudnTA&s=09' target='_blank'  rel="noopener noreferrer"><BsTwitter /></a>
          </div>
          <div>
          <a href='https://api.whatsapp.com/send?phone=7977183690' target='_blank'  rel="noopener noreferrer"><BsWhatsapp /></a>
          </div>
          <div>
          <a href='https://github.com/AadrianLeo' target='_blank'  rel="noopener noreferrer"><BsGithub /></a>
          </div>
          {/* <div>
          <FaFacebookF />
          </div> */}
          <div>
          <a href='https://www.instagram.com/aadrian_leo/' target='_blank'  rel="noopener noreferrer"><BsInstagram /></a>
          </div>
          <div>
          <a href='https://www.linkedin.com/in/dharampal-singh-35887721a/' target='_blank'  rel="noopener noreferrer"><BsLinkedin /></a>
          </div>
        </div>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" required placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" required placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              required
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">
            Thank you for getting in touch!
          </h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);